import {FC, useMemo} from 'react'
import {Badge} from 'react-bootstrap'
import {TNotification} from 'src/redux/slices/notificationSlices'
import dateformat from 'src/utils/dateformat'
import styled from 'styled-components'

const StyledListItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 1px solid #e2e2e2;
  transition: all 200ms ease;
  cursor: pointer;
  font-weight: 500;
  background-color: #fff;
  &:hover {
    background-color: #ededf7;
  }
`

const StyledListItemLeftContent = styled.div`
  width: 35%;
  display: inline-flex;
  gap: 0.5rem;
`

const StyledListItemMainContent = styled.div`
  flex: 1;
`

const StyledListItemRightContent = styled.div`
  text-align: right;
`

interface Props {
  item: TNotification
  onClick: () => void
}

export const ListItem: FC<Props> = (props) => {
  const {item, onClick} = props

  const badgeBG = useMemo(() => getBadgeBackground(item.type), [item.type])
  const typeName = useMemo(() => getNotificationType(item.type), [item.type])

  return (
    <StyledListItem
      style={{
        backgroundColor: item?.is_read ? '#f1f1f1' : 'white',
        fontWeight: item?.is_read ? 400 : 700,
      }}
      onClick={onClick}
    >
      <StyledListItemLeftContent>
        <div style={{width: 140}}>
          <Badge bg={badgeBG}>{typeName}</Badge>
        </div>
        <div style={{color: '#c1c1c1'}}>{`#${item.id}` ?? '-'}</div>
        <div className='text-truncate'>{item?.title ?? '-'}</div>
      </StyledListItemLeftContent>

      <StyledListItemMainContent>
        <div className='text-truncate'>{item?.body ?? '-'}</div>
      </StyledListItemMainContent>

      <StyledListItemRightContent>
        <div>{dateformat(item.created_at)}</div>
      </StyledListItemRightContent>
    </StyledListItem>
  )
}

function getBadgeBackground(itemType: TNotification['type']) {
  switch (itemType) {
    case 'findoc':
      return 'warning'
    case 'negotiation':
      return 'success'
    case 'order_sub_header':
      return 'info'
    case 'order_submission':
      return 'warning'
    case 'sales-order':
      return 'danger'
    case 'order':
      return 'dark'
    default:
      return 'primary'
  }
}

function getNotificationType(itemType: TNotification['type']) {
  switch (itemType) {
    case 'findoc':
      return 'FINDOC'
    case 'negotiation':
      return 'NEGOTIATION'
    case 'order_sub_header':
      return 'ORDER SUB HEADER'
    case 'order_submission':
      return 'ORDER SUBMISSION'
    case 'sales-order':
      return 'SALES ORDER'
    case 'order':
      return 'ORDER'
    case 'sip':
      return 'SIP'
    case 'contract':
      return 'CONTRACT'
    default:
      return ''
  }
}
